import { InMemoryCache } from '@apollo/client';
import { graphqls } from '@blocs.common';

const { GET_UPLOADED_PHOTO_DATA } = graphqls.media;

const defaultUploadedPhotoData = {
  __typename: 'UploadedPhotoData',
  uploadedPhotoList: [],
  forwardedPage: '',
  successfullySaved: false,
  isPrimary: false,
};

export const initializeUploadedPhotoDataState = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_UPLOADED_PHOTO_DATA,
    data: {
      uploadedPhotoData: defaultUploadedPhotoData,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      updateUploadedPhotoData: (
        _,
        { uploadedPhotoList, forwardedPage, successfullySaved, isPrimary = false },
        { cache }
      ): any[] => {
        cache.writeQuery({
          query: GET_UPLOADED_PHOTO_DATA,
          data: {
            uploadedPhotoData: {
              __typename: 'UploadedPhotoData',
              uploadedPhotoList,
              forwardedPage,
              successfullySaved,
              isPrimary,
            },
          },
        });
        return uploadedPhotoList;
      },
    },
  },
};
